import POSTS_QUERY from 'graphql/posts.query'
import { NEWS_POSTS_PER_PAGE } from '@constants'

import Archive from 'pages/[site]/news/archive/[page]'
import getGlobalSettings from '../../../../helpers/getGlobalSettings'
import getSites from '../../../../helpers/getSites'
import StateInitializer from '../../../../components/StateInitializer'
import PropTypes from 'prop-types'
import { createApolloClient } from '../../../../lib/createApolloClient'
import * as Sentry from '@sentry/nextjs'

function CategoryArchivePage(props) {
  const { globalSettings, sites, siteSlug } = props
  return (
    <StateInitializer
      globalSettings={globalSettings}
      sites={sites}
      siteSlug={siteSlug}
    >
      <Archive {...props} />
    </StateInitializer>
  )
}

CategoryArchivePage.propTypes = {
  globalSettings: PropTypes.object.isRequired,
  sites: PropTypes.array.isRequired,
  siteSlug: PropTypes.string.isRequired,
}

export default CategoryArchivePage

export async function getStaticProps({ params }) {
  const { site, categorySlug, page } = params

  Sentry.addBreadcrumb({
    category: 'getStaticProps',
    message: `Generating static props for News Category Archive page: ${categorySlug}, page: ${page} for site: ${site}`,
    level: 'info',
    data: { params },
  })

  const apolloClient = createApolloClient()

  const [globalSettings, sites, { data, error }] = await Promise.all([
    getGlobalSettings(site),
    getSites(),
    apolloClient.query({
      query: POSTS_QUERY,
      context: { site },
      variables: {
        categoryName: categorySlug,
        featuredInBlocks: true,
        withCategoriesMenu: true,
        offset: page ? (parseInt(page, 10) - 1) * NEWS_POSTS_PER_PAGE : null,
      },
    }),
  ])

  if (error) {
    Sentry.captureException(new Error(`Error loading Article props - ${error}`))
    console.error(`Error loading News Category Archive props - ${error}`)
  }

  return {
    props: {
      ...params,
      posts: data.posts.nodes,
      categoriesMenu:
        data.newsPage?.nodes?.[0]?.acfNews?.categoriesMenu?.nodes ?? null,
      offsetPagination: data.posts.pageInfo.offsetPagination,
      globalSettings,
      sites,
      siteSlug: site,
    },
    revalidate: 60 * 60, // Revalidate every hour
  }
}

export async function getStaticPaths() {
  const paths = []

  // const sites = await getSitesForStaticPaths(
  //   ({ site }) => ({
  //     query: CATEGORIES_QUERY,
  //     context: { site },
  //   }),
  //   async (data, { client, site }) =>
  //     Promise.all(
  //       data.categories.nodes
  //         .filter(c => c.slug !== 'uncategorised')
  //         .map(c =>
  //           client
  //             .query({
  //               query: POSTS_QUERY,
  //               context: { site },
  //               variables: {
  //                 categoryName: c.slug,
  //                 limit: 1,
  //               },
  //             })
  //             .then(({ data }) => [
  //               c.slug,
  //               Math.ceil(
  //                 data.posts.pageInfo.offsetPagination.total /
  //                   NEWS_POSTS_PER_PAGE
  //               ),
  //             ])
  //         )
  //     )
  // )

  // sites.forEach(site => {
  //   site[1].forEach(p => {
  //     for (let i = 0; i < p[1] - 1; i++) {
  //       paths.push({
  //         params: {
  //           site: site[0],
  //           categorySlug: p[0],
  //           page: (i + 2).toString(),
  //         },
  //       })
  //     }
  //   })
  // })

  return {
    paths,
    fallback: true,
  }
}
